import React from 'react';
import { Invoice } from '../../../shared/types/invoice';
interface InvoicePdfTemplateProps {
    invoice: Invoice;
    clientName?: string;
    clientAddress?: string;
    clientGst?: string;
    invoiceType: string;
    servicesTotal: number;
    invoiceTaxSlab?: string;
    cgstAmount: number;
    sgstAmount: number;
    igstAmount: number;
}
const fmtDate = (d?: string) => {
    if (!d) return '-';
    const dt = new Date(d);
    if (isNaN(dt.getTime())) return d;
    const dd = String(dt.getDate()).padStart(2, '0');
    const mm = String(dt.getMonth() + 1).padStart(2, '0');
    const yyyy = dt.getFullYear();
    return `${dd}-${mm}-${yyyy}`;
};
const fmtNumber = (value?: number) => Number(value || 0).toFixed(2);
export const InvoicePdfTemplate = React.forwardRef<HTMLDivElement, InvoicePdfTemplateProps>(
    (
        {
            invoice,
            clientName,
            clientAddress,
            clientGst,
            invoiceType,
            servicesTotal,
            invoiceTaxSlab,
            cgstAmount,
            sgstAmount,
            igstAmount,
        },
        ref,
    ) => (
        <div
            ref={ref}
            style={{
                position: 'fixed',
                left: '-10000px',
                top: 0,
                width: '794px',
                backgroundColor: '#ffffff',
                color: '#1f2937',
                fontFamily: 'Arial, sans-serif',
                boxSizing: 'border-box',
                padding: '0px',
                overflow: 'visible',
                minHeight: '1122px',
            }}
        >
            <div style={{ position: 'relative', width: '100%', boxSizing: 'border-box', display: 'flex', flexDirection: 'column', minHeight: '1122px', height: 'auto' }}>
                {/* Header BG */}
                <div style={{ width: '100%' }}>
                    <img
                        src="/assets/images/logo/header-bg.svg"
                        alt="header"
                        style={{ height: '94px', width: '100%', objectFit: 'cover', display: 'block' }}
                    />
                </div>
                {/* Content Container */}
                <div style={{ padding: '0 30px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginTop: '6px' }}>
                        <div style={{ height: '90px' }}>
                            <img
                                src="/assets/images/logo/main-logo.svg"
                                alt="logo"
                                style={{ height: '65px', width: 'auto', objectFit: 'contain', marginTop: '10px' }}
                            />
                        </div>
                        <div style={{ textAlign: 'right', paddingTop: '4px' }}>
                            <div style={{ fontSize: '32px', fontWeight: 700, letterSpacing: '2px' }}>INVOICE</div>
                            {/* <div style={{ marginTop: '5px', fontSize: '13px' }}>Invoice No # : {invoice.invoiceNumber}</div>
                            <div style={{ marginTop: '2px', fontSize: '13px' }}>Date: {fmtDate(invoice.invoiceDate)}</div> */}
                        </div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                        <div style={{ width: '260px', border: '1px solid #9ca3af', background: '#ffffff', minHeight: '150px', display: 'flex', flexDirection: 'column' }}>
                            <div style={{ background: '#09C2C1', color: '#000', fontSize: '12px', fontWeight: 700, padding: '6px 10px', borderBottom: '1px solid #9ca3af',lineHeight: '3px', height: '25px', }}>
                                BILL TO
                            </div>
                            <div style={{ padding: '10px', flex: 1, paddingTop: '5px' }}>
                                <div style={{ fontWeight: 800, fontSize: '16px', marginBottom: '3px', color: '#000', textTransform: 'uppercase' }}>
                                    {clientName || '-'}
                                </div>
                                <div style={{
                                    fontSize: '14px',
                                    lineHeight: '1.7',
                                    color: '#333',
                                    whiteSpace: 'pre-line',
                                    wordBreak: 'break-word',
                                }}>
                                    {clientAddress || '-'}
                                    {/* Extra blank line for longer addresses */}
                                    {!clientAddress && '\n'}
                                </div>
                                {clientGst && (
                                    <div style={{ fontSize: '13px', marginTop: '6px', color: '#333' }}>
                                        <span style={{ fontWeight: 600 }}>GSTIN: </span>{clientGst}
                                    </div>
                                )}
                            </div>
                        </div>
                        <div>
                            {/* <div style={{ fontSize: '32px', fontWeight: 700, letterSpacing: '2px' }}>INVOICE</div> */}
                            <div style={{ fontSize: '13px' }}>Invoice No # : {invoice.invoiceNumber}</div>
                            <div style={{ marginTop: '2px', fontSize: '13px' }}>Date: {fmtDate(invoice.invoiceDate)}</div>
                        </div>
                    </div>
                    <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '8px', border: '1px solid #ffffff', tableLayout: 'fixed', height: '385px' }}>
                        <colgroup>
                            <col style={{ width: '5%' }} />
                            <col style={{ width: '45%' }} />
                            <col style={{ width: '20%' }} />
                            <col style={{ width: '15%' }} />
                            <col style={{ width: '15%' }} />
                        </colgroup>
                        <thead>
                            <tr style={{ background: '#09C2C1', height: '20px' }}> {/* Ek fixed height dena behtar hai */}
                                
                                <th style={{ 
                                padding: '0 10px 14px 10px', 
                                fontSize: '13px', 
                                textAlign: 'left', 
                                verticalAlign: 'middle', 
                                lineHeight: '25px', // Ye height ke barabar honi chahiye
                                }}>
                                ID
                                </th>
                                <th style={{ 
                                padding: '0 10px 14px 10px',  
                                fontSize: '13px', 
                                textAlign: 'left', 
                                verticalAlign: 'middle', 
                                lineHeight: '25px' 
                                }}>
                                Service / Description
                                </th>
                                <th style={{ 
                                padding: '0 10px 14px 10px', 
                                fontSize: '13px', 
                                textAlign: 'right', 
                                verticalAlign: 'middle', 
                                lineHeight: '25px' 
                                }}>
                                Rate Per Unit/Hour
                                </th>
                                <th style={{ 
                                padding: '0 10px 14px 10px', 
                                fontSize: '13px', 
                                textAlign: 'right', 
                                verticalAlign: 'middle', 
                                lineHeight: '25px' 
                                }}>
                                Unit/Hour
                                </th>
                                <th style={{ 
                                padding: '0 10px 14px 10px', 
                                fontSize: '13px', 
                                textAlign: 'right', 
                                verticalAlign: 'middle', 
                                lineHeight: '25px' 
                                }}>
                                Amount
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {Array.from({ length: 5 }).map((_, idx) => {
                                const svc = (invoice.services || [])[idx];
                                return (
                                    <tr key={idx} style={{ background: '#f3f4f6', verticalAlign: 'top' }}>
                                        <td style={{ padding: '10px 8px', fontSize: '14px', height: '62px' }}>{svc ? idx + 1 : ''}</td>
                                        <td style={{ padding: '10px 8px', fontSize: '14px', wordBreak: 'break-word', whiteSpace: 'pre-wrap', lineHeight: '1.6', height: '62px' }}>{svc?.description || ''}</td>
                                        <td style={{ padding: '10px 8px', fontSize: '14px', textAlign: 'right', wordBreak: 'break-word', height: '62px' }}>{svc?.ratePerUnitHour || ''}</td>
                                        <td style={{ padding: '10px 8px', fontSize: '14px', textAlign: 'right', height: '62px' }}>{svc?.unitHour || ''}</td>
                                        <td style={{ padding: '10px 8px', fontSize: '14px', textAlign: 'right', height: '62px' }}>{svc ? fmtNumber(svc.amount) : ''}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                    <div style={{ display: 'flex', gap: '15px', marginTop: '10px' }}>
                        <div style={{ flex: 1, fontSize: '12px' }}>
                            <div style={{ fontSize: '15px', fontWeight: 700, marginBottom: '6px' }}>Additional Note:</div>
                            <div style={{ marginBottom: '8px', fontSize: '12px' }}>{invoice.additionalNote || '-'}</div>
                            <div style={{ fontSize: '15px', fontWeight: 700, marginBottom: '6px', marginTop: '8px' }}>Others:</div>
                            <div style={{ fontSize: '12px', lineHeight: 1.5 }}>Any concerns with price or errors in invoice please</div>
                            <div style={{ fontSize: '12px', lineHeight: 1.5 }}>mail me at: <span style={{ color: '#09C2C1' }}>info@codeflixweb.com</span></div>
                        </div>
                        <div style={{ width: '240px', fontSize: '14px' }}>
                            <div style={{ border: '1px solid #9ca3af', padding: '9px 12px', display: 'flex', justifyContent: 'space-between', fontWeight: 600 }}>
                                <span>Tax</span><span>{fmtNumber(invoice.totalTax)}</span>
                            </div>
                            {invoice.totalDiscount > 0 && (
                                <div style={{ border: '1px solid #9ca3af', padding: '9px 12px', display: 'flex', justifyContent: 'space-between', fontWeight: 600, marginTop: '4px' }}>
                                    <span>Discount</span>
                                    <span>{fmtNumber(invoice.totalDiscount)}</span>
                                </div>
                            )}
                            <div style={{ border: '1px solid #6b7280', padding: '10px 12px', display: 'flex', justifyContent: 'space-between', fontWeight: 800, marginTop: '4px', fontSize: '15px' }}>
                                <span>Total</span><span>{fmtNumber(invoice.totalAmount)}/-</span>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Footer section updated to be in-flow instead of absolute */}
                <div style={{ width: '100%', marginTop: 'auto' }}>
                    <div style={{ textAlign: 'center', fontSize: '30px', fontWeight: 700, color: '#09C2C1', marginBottom: '10px' }}>
                        Thanks for your Business.
                    </div>
                    <img
                        src="/assets/images/logo/footer-bg.svg"
                        alt="footer"
                        style={{ height: '140px', width: '100%', objectFit: 'cover', display: 'block' }}
                    />
                </div>
            </div>
        </div>
    ),
);
InvoicePdfTemplate.displayName = 'InvoicePdfTemplate';